import { render, staticRenderFns } from "./UploadDocumentPreference.vue?vue&type=template&id=733b56e1"
import script from "./UploadDocumentPreference.vue?vue&type=script&lang=js"
export * from "./UploadDocumentPreference.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentPreference.vue?vue&type=style&index=0&id=733b56e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports